import React, { useState, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import Select, { components } from "react-select";
import { PROCEDURE_SLOTS } from "../Constants";
import afterLoginApiAxios from "../../../../Util/API Calls/afterLogin";
import TimePickerModal from "../Modals/TimePickerModal";
import MyScheduleModal from "../Modals/MyScheduleModal";
import Loader from "../../../UI Component/Loader/Loader";
import DoctorContext from "../../../ClinicComponents/ClinicWrapper/DoctorContext";
import swal from "sweetalert";
import { APPLICABLE_ROLE } from "../../../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../../Util/constants";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";
import { roundToTwoDecimalPlaces } from "../ViewLogs/helper";
import GSTDropdown from "./Common/GSTDropdown";
import { calculateDiscountedAmount, callGetDoctorResourceAPI } from "../helper";
export default function InClinicRegularForm(props) {
  const {
    openConsultationModal,
    consultationType,
    slotValue,
    handleSlotType,
    handleEnableAllSLotButton,
    handleConsultationCounter,
    handleTitle,
    staffDoctor,
    warningMsg,
  } = props;
  const { register, handleSubmit, errors, control, setValue } = useForm({});
  const [fees, setFees] = useState(0);
  const [instruction, setInstruction] = useState("");
  const [showtimepicker, setTimePicker] = useState(false);
  const [peviousSlotValue, setPreviousSlotsVal] = useState({});
  const [showConsultationModal, setConsultationModal] = useState(false);
  const [loading, setLoader] = useState(false);
  const [commission, setCommission] = useState("");
  const [totalCommission, setTotalCommission] = useState(0);
  const [gstPercentage, setGstPercentage] = useState(0);
  const [hsnValue, setHsnValue] = useState("");
  const [hsnMandatory, setHsnMandatory] = useState(false);
  const [CTAEnable, setCTAEnable] = useState(false);
  const [hsnError, setHsnError] = useState(false);

  const doctor_context = useContext(DoctorContext);
  const user_type = localStorage.getItem("user_type");
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );

  useEffect(() => {
    const isGstSet = gstPercentage !== 0;
    setHsnMandatory(isGstSet);
    setCTAEnable(isGstSet);
  }, [gstPercentage]);

  useEffect(() => {
    const isInvalidHSN = hsnValue?.length < 6;
    setCTAEnable(gstPercentage !== 0 ? isInvalidHSN : false);
    setHsnError(!!hsnValue && isInvalidHSN);
  }, [gstPercentage, hsnValue]);

  useEffect(() => {
    getConsultationSettings();
  }, []);

  function getConsultationSettings() {
    let api_url = "";
    let payload = {};
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      api_url = "/clinic/get-consultation-settings-rev";
      payload = {
        doctor_id:
          doctorRole == USER_ROLE.DOCTOR_ADMIN ||
          doctorRole === USER_ROLE.RESOURCE_ADMIN ||
          user_type == APPLICABLE_ROLE.STAFF
            ? staffDoctor.id
            : userId,
        clinic_id: doctor_context?.clinic_id,
      };
    } else {
      api_url = "/doctor/get-consultation-settings-rev";
      payload = {
        doctor_id:
          user_type === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
      };
    }
    afterLoginApiAxios({
      method: "post",
      url: api_url,
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        ...payload,
        consultation_type: consultationType.value,
      },
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          if (
            response.data &&
            response.data.data &&
            response.data.data.length == 1
          ) {
            let responseData = response.data.data[0];
            let consultation_duration = PROCEDURE_SLOTS.find(
              (data) => data.slotType == responseData.slot_type
            );
            handleSlotType(consultation_duration);
            setValue("fees", responseData.fees);
            setValue("slots", consultation_duration);
            setFees(Number(responseData.fees));
            setValue("instruction", responseData.instruction);
            setCommission(
              responseData.doctor_commission_percentage
                ? responseData.doctor_commission_percentage
                : ""
            );
            setInstruction(responseData.instruction);
            handleEnableAllSLotButton(false);
            setPreviousSlotsVal(consultation_duration);
            setValue(
              "enable_online",
              responseData.online_payment_enabled === "True" ? true : false
            );
            setGstPercentage(responseData?.gst ?? 0);

            setHsnValue(responseData?.hsn_code);
          } else {
            handleEnableAllSLotButton(true);
          }
        } else {
          handleEnableAllSLotButton(true);
        }
      })
      .catch((error) => {
        C2CConsole.error(error);
      });
  }

  const onSubmit = (data) => {
    let add_api_url = "";
    let payload = {};
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      add_api_url = "/clinic/update-consultation-settings";
      payload = {
        doctor_id:
          doctorRole == USER_ROLE.DOCTOR_ADMIN ||
          doctorRole === USER_ROLE.RESOURCE_ADMIN ||
          user_type == APPLICABLE_ROLE.STAFF
            ? staffDoctor.id
            : userId,
        clinic_id: doctor_context?.clinic_id,
        "authorizer-principal-id": {
          user_type: user_type == APPLICABLE_ROLE.STAFF ? 4 : 1,
          user_id: userId,
          agent: "web",
        },
        ...(user_type == APPLICABLE_ROLE.STAFF && {
          staff_id: staffId,
        }),
        user_type: user_type == APPLICABLE_ROLE.STAFF ? 4 : 1,
      };
    } else {
      add_api_url = "/doctor/update-consultation-settings";
      payload = {
        doctor_id:
          user_type === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
        "authorizer-principal-id": {
          user_type: user_type == APPLICABLE_ROLE.STAFF ? 4 : 1,
          user_id: userId,
          agent: "web",
        },
        ...(user_type == APPLICABLE_ROLE.STAFF && {
          staff_id: staffId,
        }),
        user_type: user_type == APPLICABLE_ROLE.STAFF ? 4 : 1,
      };
    }
    setLoader(true);
    afterLoginApiAxios({
      method: "post",
      url: add_api_url,
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        data: {
          ...payload,
          fees: data.fees,
          slot_type: data.slots.slotType,
          instruction: data.instruction.trim(),
          consultation_type: consultationType.value,
          reduced_day_count: "0",
          discount_percentage: "",
          discounted_amount: "",
          enable_online_payment: data.enable_online,
          doctor_commission_percentage: commission
            ? roundToTwoDecimalPlaces(commission)
            : "",
          gst: gstPercentage,
          hsn_code: hsnValue,
        },
      },
    })
      .then((response) => {
        if (response?.data) {
          if (response.data.statusCode === 200) {
            getConsultationSettings();
            if (doctor_context?.clinic_id) {
              callGetDoctorResourceAPI(doctor_context?.clinic_id);
            }

            if (peviousSlotValue.slotType != data.slots.slotType) {
              setTimePicker(true);
            } else {
              setConsultationModal(true);
            }
          }
          if (response.data.statusCode === 540) {
            getConsultationSettings();
            swal({
              text: warningMsg,
              icon: "warning",
              button: "OK",
            });
          }
        }
        setLoader(false);
      })
      .catch((error) => {
        C2CConsole.error(error);
      });
  };

  useEffect(() => {
    let slots = PROCEDURE_SLOTS.filter((data) => data.slotType == 0);
    setValue("slots", slots[0]);
    setValue("fees", 0);
    setValue("days", 0);
  }, []);

  useEffect(() => {
    calculateTotalAmount();
  }, [commission, fees]);

  // function to handle fees
  const handleFees = (value) => {
    setFees(value);
  };

  const preventNegativeInput = (event) => {
    const invalidKeys = ["-", "e", "+", "."];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  };

  const handleFeesEdit = (fees) => {
    if (isNaN(fees)) {
      return "";
    }
    let costBeforeRoundup = (Number(fees) / 94.4287) * 100;
    let lowerLimit =
      Number(Math.floor(costBeforeRoundup).toFixed(2)) + Number(0.01);
    const finalCost =
      costBeforeRoundup > lowerLimit
        ? parseFloat(costBeforeRoundup.toFixed(2))
        : Math.floor(lowerLimit);

    return finalCost;
  };

  const calculateTotalAmount = () => {
    // Calculate total after discount
    const discountedAmount = fees - (fees * 0) / 100;
    // Calculate total after commission
    const totalAmount =
      discountedAmount - (discountedAmount * commission) / 100;

    // Calculate total commission
    let totalCommissionFee = discountedAmount - totalAmount;

    setTotalCommission(parseFloat(totalCommissionFee.toFixed(2)));
  };
  const handleCommission = (value) => {
    setCommission(value);
  };

  //function for instruction
  const handleInstruction = (e) => {
    setInstruction(e.target.value);
  };

  const CaretDownIcon = () => {
    return <i class="fa fa-caret-down fa-2x" aria-hidden="true"></i>;
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };

  return (
    // TODO: add edit procedure settings form
    <>
      {/* <div>In-Clinic form</div> */}
      {loading ? <Loader /> : null}
      <form onSubmit={handleSubmit(onSubmit)}>
        <section className="form-wrapper">
          <div className="row">
            <div className="col-lg-12 col-12 form-wrapper-input">
              <label className="required">Consultation Duration</label>
              <Controller
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                name={"slots"}
                render={({ onChange, value, name }) => (
                  <Select
                    className="select-field"
                    onChange={(value) => {
                      onChange(value);
                    }}
                    options={PROCEDURE_SLOTS}
                    placeholder="Specify Duration"
                    value={value}
                    name={name}
                    components={{ DropdownIndicator }}
                  />
                )}
              />
              {errors.slots ? (
                <p className="error">Please enter the duration.</p>
              ) : (
                ""
              )}
            </div>
            <div className="col-lg-12 col-12 form-wrapper-input mt-3">
              <label className="required" for="fees">
                Consultation Fees
              </label>
              <div class="input-group-prepend fee-input">
                <span class="input-group-text rs_style">₹</span>
                <input
                  type="number"
                  name="fees"
                  min={0}
                  autoComplete="off"
                  className="inputStyle"
                  ref={register({ required: true })}
                  onChange={(e) => handleFees(e.target.value)}
                  onKeyDown={(e) => preventNegativeInput(e)}
                />{" "}
                {/**, pattern: onlyDigitRegex */}
              </div>
              <p>Fees seen by Patient : ₹ {handleFeesEdit(fees)}</p>
              {errors.fees ? <p className="error">Please enter fees.</p> : ""}
            </div>
            <div className="col-lg-12 col-12 form-wrapper-input mt-3">
              <label for="instruction">Add Instructions (optional)</label>
              <textarea
                className="input-scrollStyle"
                name="instruction"
                autoComplete="off"
                ref={register}
                maxLength="500"
                onChange={handleInstruction}
              />{" "}
              {/**, pattern: onlyDigitRegex */}
              <p
                className={
                  500 - instruction.length == 0
                    ? "text-red"
                    : 500 - instruction.length > 0 &&
                      500 - instruction.length < 500
                    ? "text-green"
                    : ""
                }
              >
                Characters left : {500 - instruction.length} of 500
              </p>
            </div>
            <GSTDropdown
              gstValue={gstPercentage}
              hsnValue={hsnValue}
              hsnError={hsnError}
              hsnMandatory={hsnMandatory}
              amountWithoutGST={calculateDiscountedAmount(fees)}
              setHsnValue={setHsnValue}
              handleGST={(value) => {
                setGstPercentage(value);
              }}
            />
            <div className="col-lg-12 col-12 form-wrapper-input mt-3">
              <label class="container-checkbox">
                Enable Online Payment
                <input type="checkbox" name="enable_online" ref={register} />
                <span class="checkmark"></span>
              </label>
              <p className="checkbox-p">6% service charge will be applied</p>
            </div>
          </div>

          {(doctorRole === USER_ROLE.DOCTOR_ADMIN ||
            doctorRole === USER_ROLE.RESOURCE_ADMIN ||
            doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
            doctorRole === USER_ROLE.RESOURCE_CONSULTANT) && (
            <div className="form-wrapper-input mt-3">
              <label for="discount">Doctor Commission (Optional)</label>
              <div class="input-group-prepend fee-input">
                <span class="input-group-text rs_style">Commission %</span>
                <input
                  type="number"
                  name="commission"
                  value={commission}
                  min={0}
                  max={100}
                  step="any"
                  autoComplete="off"
                  className="dis_inputStyle"
                  ref={register}
                  disabled={
                    doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
                    doctorRole === USER_ROLE.RESOURCE_CONSULTANT
                  }
                  onChange={(e) => handleCommission(e.target.value)}
                />{" "}
              </div>
              <p>Commission Payout to the Doctor is : ₹ {totalCommission}</p>
            </div>
          )}
          <div className="mt-4 text-center">
            <button
              className="btn primary-cta-button rounded-pill py-2 px-2"
              disabled={CTAEnable || hsnError}
            >
              Save
            </button>
          </div>
        </section>
      </form>
      <TimePickerModal
        open={showtimepicker}
        handleCloseTimeModal={() => {
          setTimePicker(false);
        }}
        typeOfSlot={"add"}
        openConsultationModal={openConsultationModal}
        consultationType={consultationType}
        slotValue={slotValue}
        handleSaveTimerModal={() => {
          setTimePicker(false);
          openConsultationModal();
          handleConsultationCounter();
        }}
        handleTitle={handleTitle}
        staffDoctor={staffDoctor}
      />
      <MyScheduleModal
        show={showConsultationModal}
        name={"consultationModal"}
        okayClickHandler={() => setConsultationModal(false)}
      />
    </>
  );
}
